import React, { Fragment } from 'react';
import get from 'lodash.get';
import clsx from 'clsx';
import { createDtmAndTrackActionHandler } from 'src/universal/utils/analyticsTracking';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { Link } from 'acq-components/lib/base-components/Link/Link';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getIsUserCard, isGCSMember } from 'src/universal/redux/cardMemberInfo';
import {
  getPdpLinks,
  getCardWithPznData,
  getAddAnEmployeeHoverText
} from 'page_modules/business-pdp/redux';
import { getIsSuppCardsModalOpen } from 'src/universal/redux/page';
import { suppModalState } from 'page_modules/business-pdp/utils/setModalStateAction';
import { Size, Icon } from '@americanexpress/aqx-components';
import ApplyAndUpgradeCta from 'src/universal/components/ApplyOrUpgradeCta';
import defaultStyles from './__styles__/index.scss?modules';
import tooltipStyles from 'src/universal/components/SuppModal/components/styles/toolTipWrapper.scss?modules';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

const parentToDtmTag = {
  _LeftRail: 'leftrail',
  _ReinforcementBanner: 'reinforcement'
};

const ApplyAndAddEmpCard = React.memo(
  ({
    links,
    isCardMemberCard,
    styles = defaultStyles,
    parent = '',
    card = {},
    dispatch,
    suppModalOpen,
    isUserGcsMember,
    addAnEmployeeScrollDtm,
    addEmpHoverText,
    hasUpgradeCta
  }) => {
    const addAnEmployeeDtm = get(links, 'addAnEmployee.dtm') && {
      ...links.addAnEmployee.dtm,
      eventAsset: `add-employee${parent}`
    };
    const addAnEmployeeIconDtm = get(links, 'addAnEmployeeIcon.dtm') && {
      ...links.addAnEmployeeIcon.dtm,
      eventAsset: `${links.addAnEmployeeIcon.dtm.eventAsset}_${parent}`
    };
    const toggleModal = () => {
      dispatch(suppModalState(!suppModalOpen, parentToDtmTag[parent]));
    };

    return (
      <Fragment>
        <div
          className={clsx(styles.ctaHolder, {
            [styles.hasUpgradeCta]: hasUpgradeCta
          })}
        >
          <ApplyAndUpgradeCta allowUpgradeCta={true} shortName={card.shortName} />
        </div>
        {isCardMemberCard && (
          <div className={styles.addEmpHolder}>
            <LazyScrollMetricTracker scrollDtm={addAnEmployeeScrollDtm}>
              <Link
                href={get(links, 'addAnEmployee.url') || ''}
                title={addEmpHoverText}
                onClick={() => {
                  createDtmAndTrackActionHandler({
                    dtmObj: addAnEmployeeDtm,
                    actionTracking: get(links, 'addAnEmployee.actionTracking'),
                    appendToActionAttr: parent
                  })();
                }}
              >
                <Sanitizer
                  Component="div"
                  className={styles.addEmployee}
                  safelySetInnerHTML={get(links, 'addAnEmployee.text') || ''}
                />
              </Link>
            </LazyScrollMetricTracker>
            {isUserGcsMember && (
              <span
                className={clsx(styles.addEmployeeInfo, tooltipStyles.pdpIcon)}
                onClick={e => {
                  e.stopPropagation();
                  toggleModal();
                  sendDTMClickEvent(addAnEmployeeIconDtm);
                }}
              >
                <Icon
                  directory="dls"
                  imageName="dls-icon-info-tooltip"
                  $size={Size.XS}
                />
              </span>
            )}
          </div>
        )}
      </Fragment>
    );
  }
);

const mapStateToProps = (state, ownProps) => {
  const urlEep = get(ownProps, 'params.eep') || '';
  const currentCard = getCardWithPznData(state);
  const { pmcCode } = currentCard;
  return {
    links: getPdpLinks(urlEep)(state),
    isCardMemberCard: getIsUserCard(pmcCode)(state),
    card: currentCard,
    suppModalOpen: getIsSuppCardsModalOpen(state),
    isUserGcsMember: isGCSMember(state),
    addEmpHoverText: getAddAnEmployeeHoverText(state)
  };
};

export default withRouter(connect(mapStateToProps)(ApplyAndAddEmpCard));
